import React, { useContext } from "react";
import { useIntl } from "react-intl";
import { Button, Typography, Box } from "@mui/material";
import classNames from "classnames";
import { StoreContext } from "../../../../../store/StoreProvider";
import CustomTooltip from "../components/CustomTooltip";
import Loading from "../components/Loading";
import { prepareEditDialog } from "../utils/prepareEditDialog";
import NestedList from "./components/NestedList";
import { editDialogConfig, TooltipTitle } from "../constants/textConfig";
import tooltipIcon from "../../../../../../images/icon_tooltip/icon_tooltip_24x24.svg";

const EvnCtgSettingTool = () => {
  const intl = useIntl();
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const {
    evnCtgSettingToolIsLoading,
    filter: {
      eventTypes: { origin, custom, initial },
    },
  } = sna;

  const handleAddNewMainEvn = () => {
    prepareEditDialog(dispatch, editDialogConfig.addMainEvn.name);
  };

  const getMenuItems = (pid, evtTypeId, name) => {
    const isInMainOrigin = origin.some(
      (el) => el.evtTypeId === evtTypeId && pid === "EVTTYPE0"
    );
    const isInMainCustom = custom.some(
      (el) => el.evtTypeId === evtTypeId && pid === "EVTTYPE0"
    );
    const isInSubCustom = custom.some(
      (el) => el.evtTypeId === evtTypeId && pid !== "EVTTYPE0"
    );

    const menuItems = [];

    if (isInMainOrigin || isInMainCustom) {
      menuItems.push({
        name: "新增子事件",
        func: () =>
          prepareEditDialog(dispatch, editDialogConfig.addSubEvn.name, {
            curMainEvn: name,
          }),
      });
    }

    if (isInSubCustom || isInMainCustom) {
      menuItems.push({
        name: "重新命名",
        func: () =>
          prepareEditDialog(
            dispatch,
            pid === "EVTTYPE0"
              ? editDialogConfig.updateMainEvn.name
              : editDialogConfig.updateSubEvn.name,
            {
              evtTypeId,
              curMainEvn: pid === "EVTTYPE0" ? name : "",
              curSubEvn: pid !== "EVTTYPE0" ? name : "",
            }
          ),
      });
      menuItems.push({
        name: "刪除",
        func: () =>
          prepareEditDialog(dispatch, editDialogConfig.deleteEvn.name, {
            evtTypeId,
          }),
      });
    }

    return menuItems;
  };

  const nestedListData = initial
    .filter(({ pid }) => pid === "EVTTYPE0")
    .map((item) => ({
      ...item,
      subItems: initial
        .filter((el) => el.pid === item.evtTypeId)
        .map((subItem) => ({
          ...subItem,
          subEvnMenuItems: getMenuItems(
            subItem.pid,
            subItem.evtTypeId,
            subItem.name
          ),
        })),
      mainEvnMenuItems: getMenuItems(item.pid, item.evtTypeId, item.name),
    }));

  return (
    <Box
      sx={{
        "&.noPadding": { padding: "0 !important" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
      }}
      className="noPadding"
    >
      <Box
        sx={{
          padding: "24px 24px 16px 24px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          textAlign="left"
          variant="body1"
          sx={{ color: "#fff", marginRight: "4px", alignContent: "center" }}
          className={classNames(
            "sna-sidebar__title",
            "sna-sidebar__title--evn-ctg-setting-tool"
          )}
        >
          {intl.formatMessage({
            id: "sna.sidebar.evnCtgSetting.title",
            defaultMessage: "篩選",
          })}
        </Typography>
        <CustomTooltip title={TooltipTitle} icon={tooltipIcon} />
      </Box>
      <Box
        sx={{
          color: "#fff",
          width: "100%",
          padding: "0 24px",
          height: "calc(100% - 137px)",
          overflowY: "auto",
        }}
      >
        {evnCtgSettingToolIsLoading ? (
          <Loading />
        ) : (
          <NestedList items={nestedListData} />
        )}
      </Box>
      <Box sx={{ padding: "16px 24px", borderTop: "0.5px solid #5D5D5D" }}>
        <Button
          sx={{
            padding: "8px 24px",
            backgroundColor: "#3BBFF0",
            "&:hover": { backgroundColor: "#35A9D4" },
            borderRadius: "6px",
            color: "#FFFFFF",
            width: "100%",
          }}
          onClick={handleAddNewMainEvn}
        >
          新增主事件
        </Button>
      </Box>
    </Box>
  );
};

export default EvnCtgSettingTool;
